export const peersCelestia = {   
    "peers":""
}